import { Reveal, SectionLabel } from "./Reveal";
import { scrollTo } from "./Navbar";

const facts = [
  ["Background", "Construction director & licensed builder"],
  ["Family", "Father of two boys"],
  ["Base", "Melbourne, Australia"],
];

const values = ["Respect", "Hard Work", "Accountability", "Legacy"];

export default function Founder() {
  return (
    <section
      id="founder"
      className="relative py-24 sm:py-32 lg:py-40 border-t border-white/5"
      data-testid="founder-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative">
                <div className="absolute -inset-px bg-gradient-to-b from-white/20 to-transparent" />
                <img
                  src="/founder.png"
                  alt="Mārere Te Kanawa, founder of Mind Before Markets"
                  className="relative w-full grayscale object-cover"
                  style={{ aspectRatio: "4/5", objectPosition: "top" }}
                  data-testid="founder-portrait"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <SectionLabel>The Founder</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-heading text-4xl sm:text-5xl font-light tracking-tight">
                Mārere Te Kanawa
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-base lg:text-lg text-zinc-400 font-light leading-relaxed">
                Before the charts, there were building sites. As a former
                construction director and licensed builder, Mārere spent years
                leading teams, managing risk and holding a standard, learning
                that nothing of value is built without discipline, repetition
                and respect for the process.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-5 text-base lg:text-lg text-zinc-400 font-light leading-relaxed">
                A self taught trader and a father of two boys, he built his edge
                the same way he built on site, through consistency, not
                shortcuts. MBM exists to pass that on: to teach real, durable
                skills, and to leave something meaningful for the next
                generation of traders and for his own family.
              </p>
            </Reveal>

            <Reveal delay={0.4}>
              <div className="mt-10 flex flex-wrap gap-2.5">
                {values.map((v) => (
                  <span
                    key={v}
                    className="section-label text-[10px] text-zinc-300 border border-white/15 px-4 py-2"
                    data-testid={`founder-value-${v}`}
                  >
                    {v}
                  </span>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.5}>
              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
                {facts.map(([k, v]) => (
                  <div key={k}>
                    <div className="section-label text-[9px] text-zinc-600">{k}</div>
                    <div className="mt-2 text-sm text-zinc-200 font-light leading-snug">{v}</div>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.6}>
              <button
                onClick={() => scrollTo("apply")}
                className="btn-glass mt-12 text-white px-8 py-4 text-sm font-medium tracking-wide"
                data-testid="founder-apply-btn"
              >
                Train With Mārere
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
